import { AxiosError, AxiosResponse } from 'axios';
import { apiInstance, BASE_URL } from '../../../libs/axios/axiosInstance';
import api from 'libs/axios/api';
import { apiService } from 'libs/axios/services';

export const loginFetcher = async (data: IRequestLogin): Promise<AxiosResponse<ILogin> | Error> => {
    try {
        const response = await apiInstance.post(`${BASE_URL}/auth/login`, JSON.stringify(data));
        return response.data;
    } catch (error) {
        if (error instanceof AxiosError) {
            return Error(error?.response?.data.error);
        }
        if (error instanceof Error) {
            return Error(error.message);
        }
        return Error(`[getChatFetcher Fail]: ${error}`);
    }
};

export const postContractCode = (
    request: ContractCode,
): Promise<ApiResponse<BaseContractResponse>> => {
    return apiService.post<ContractCode, BaseContractResponse>(
        api.postContractCode,
        request,
        undefined,
        true,
    );
};

export const getContractCode = (
    contractCode: String,
): Promise<ApiResponse<BaseContractResponse>> => {
    return apiService.get<{ item_id: String }, BaseContractResponse>(
        api.postContractCode,
        { item_id: contractCode },
        undefined,
        false,
    );
};
